import { render, staticRenderFns } from "./CryoemReviewDashboard.vue?vue&type=template&id=53148ed4&scoped=true&"
import script from "./CryoemReviewDashboard.vue?vue&type=script&lang=js&"
export * from "./CryoemReviewDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53148ed4",
  null
  
)

export default component.exports